import Vue from 'vue'
import Vuex from 'vuex'
import backendeleres from './backendeleres.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	bejelentkezve: undefined,
    backendeleres: backendeleres.backendeleres,
    admin: undefined
  },
  mutations: {
  	bejelentkezve(state,allas){
  		state.bejelentkezve=allas;
  	},
    admin(state,allas){
      state.admin=allas
    }
  },
  actions: {
  	bejelentkezesallasvaltas({commit}, bejelentkezve){
  		commit('bejelentkezve',bejelentkezve)
  	}
  }
})
